import _ from 'lodash';

import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';
import ConfigService from '../services/ConfigService';

const AppActions = {

    initialize() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APP_INITIALIZED
        });
    },

    activityDetected: _.throttle(function (event) {
        AppDispatcher.dispatch({
            firedEvent: event,
            actionType: ActionTypes.ACTIVITY_DETECTED
        });
    }, 15000, { leading: true }),

    async loadBanner () {
        try {
            const banner = await ConfigService.loadBannerConfig();
            AppDispatcher.dispatch({
                actionType: ActionTypes.BANNER_CONFIG_LOADED,
                banner
            });
        } catch (e) {
            // We don't want the user to see an error if the banner load Failed
            // So just log it out
            console.error('Failed to load banner config');
        }
    },

    dismissMessageBanner (id) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.BANNER_DISMISSED,
            id
        });
    },

    routeChanged (location) {
        AppDispatcher.dispatch({
            location,
            actionType: ActionTypes.ROUTE_CHANGED
        });
    },

    toggleFeature (feature, value) {
        AppDispatcher.dispatch({
            feature,
            value,
            actionType: ActionTypes.FEATURE_TOGGLED
        });
    },

    setFeatureVariant (feature, variant) {
        AppDispatcher.dispatch({
            feature,
            variant,
            actionType: ActionTypes.FEATURE_VARIANT_UPDATED
        });
    },

    enableTracking () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TRACKING_ENABLED
        });
    },

    disableTracking () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.TRACKING_DISABLED
        });
    }

};


export default AppActions;
